import React, { useEffect, useState } from 'react';
import PageTitle from '../common/PageTitle';
import { DocumentsCardWrapper, DocumentsTabsWrapper, Wrapper } from './styled';
import { DOCUMENTS_PAGE_TABS, DOCS_STATUSES, HOST, CORRECTION_MODS } from '../../config';
import moment from 'moment';
import Button from '../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAdminSign,
  fetchClientSign,
  fetchExportDocuments,
  fetchGetDocuments,
} from '../../actions/documents';
import FilterRow from './FilterRow';
import Pagination from '../common/Pagination';
import { useFormik } from 'formik';
import TagManager from 'react-gtm-module';
import { fetchActivateAccount, fetchSignUp } from '../../actions/auth';
import { showModal } from '../../actions/modal';
import { MOCK_SIGN } from './MOCK_SIGN';
import { downloadFileViaDirectLink, parseError } from '../../helpers';
import { compareOperations } from '../Items/CollectionsPage/SingleCollection';
import { getCertificates, signDocument } from '../../utils/criptoSignDocument';
import { toast } from 'react-toastify';
import SignsBlock from './SignsBlock';

const THEAD_ITEMS = [
  'Документ',
  'Поставка',
  'Статус',
  'Подпись исполнителя',
  'Подпись клиента',
  '',
];

export const renderStatusSpan = (item) => {
  switch (item.status) {
    case DOCS_STATUSES.NEW:
      return <span className="color-new">{item.statusText}</span>;
    case DOCS_STATUSES.SIGNED_PERFORMER:
      return <span className="color-signed-performer">{item.statusText}</span>;
    case DOCS_STATUSES.SIGNED_CLIENT:
      return <span className="color-signed-client">{item.statusText}</span>;
    case DOCS_STATUSES.APPROVED_CLIENT:
      return <span className="color-approved-client">{item.statusText}</span>;
    case DOCS_STATUSES.APPROVED_AUTO:
      return <span className="color-approved-auto">{item.statusText}</span>;
    case DOCS_STATUSES.NOT_APPROVED:
      return <span className="color-not-approved">{item.statusText}</span>;
    default:
      return <span className="color-not-present">{item.statusText}</span>;
  }
};

const DocumentsPage = (props) => {
  const { setCustomHeader } = props;
  const [locationState, setLocationState] = useState();
  const [docs, setDocs] = useState();
  const dispatch = useDispatch();
  const { fetchedDocs } = useSelector((state) => state.documents);

  const formik = useFormik({
    initialValues: {
      activeTab: '',
      id: null,
      date_from: null,
      date_to: null,
      doc_types: null,
      statuses: null,
      page: 0,
      size: 15,
    },
  });

  const { values, errors, setFieldValue } = formik;

  const handleGetDocs = async () => {
    let sendObj = Object.assign(
      {},
      {
        activeTab: values.activeTab || 'MH-1',
        id: values.id,
        date_from: values.date_from !== 'Invalid date' ? values.date_from : null,
        date_to: values.date_to !== 'Invalid date' ? values.date_to : null,
        doc_types: values.doc_types,
        statuses: values.statuses,
        size: values.size,
        page: values.page,
      },
    );

    if (typeof page !== 'undefined') sendObj.page = 1;

    if (locationState) {
      sendObj = {
        ...sendObj,
        ...locationState,
      };
    }

    return await dispatch(fetchGetDocuments(sendObj));
  };

  useEffect(() => {
    handleGetDocs(values);
  }, [values]);

  const handleOpenTab = (tab) => {
    setFieldValue('page', 0);
    setFieldValue('doc_types', tab.id);
    setFieldValue('activeTab', tab.id);
  };

  const handleAdminSign = (item) => {
    dispatch(fetchAdminSign({ id: item.humanId }));
  };
  const extractCN = (certInfo) => {
    const match = certInfo.match(/CN=([^;]+)/);
    return match ? match[1].trim() : null;
  };

  const handleClientApprove = async (item) => {
    try {
      const certs = await getCertificates();

      if (certs.length === 0) {
        toast.error('Сертификаты не найдены');

        return;
      } else if (certs.length === 1) {
        const certName = extractCN(certs[0].name);
        const signedBase64 = await signDocument(certName, item.url);
        dispatch(
          fetchClientSign({
            docId: item.humanId,
            signData: signedBase64,
          }),
        );

        toast.info('Документ успешно подписан!');
      } else {
        dispatch(
          showModal('CertificatesModal', {
            certOptions: certs,
            selectedDoc: item,
            extractCN,
          }),
        );
      }
    } catch (err) {
      toast.error('Сертификаты не найдены ' + parseError(err));
    }
  };

  const handleClientReject = (item) => {
    dispatch(showModal('ClientComment', item));
  };

  const handleExportDocument = async (item) => {
    try {
      const res = await dispatch(
        fetchExportDocuments({
          docId: item.humanId,
        }),
      );
      downloadFileViaDirectLink(res.fileUrl, 'test');
    } catch (e) {}
  };

  const handleShowDocHistory = (item) => {
    dispatch(showModal('DocHistory', item));
  };

  const renderStatusSpan = (item) => {
    switch (item.status) {
      case DOCS_STATUSES.NEW:
        return <span className="color-new">{item.statusText}</span>;
      case DOCS_STATUSES.SIGNED_PERFORMER:
        return <span className="color-signed-performer">{item.statusText}</span>;
      case DOCS_STATUSES.SIGNED_CLIENT:
        return <span className="color-signed-client">{item.statusText}</span>;
      case DOCS_STATUSES.APPROVED_CLIENT:
        return <span className="color-approved-client">{item.statusText}</span>;
      case DOCS_STATUSES.APPROVED_AUTO:
        return <span className="color-approved-auto">{item.statusText}</span>;
      case DOCS_STATUSES.NOT_APPROVED:
        return <span className="color-not-approved">{item.statusText}</span>;
      default:
        return <span className="color-not-present">{item.statusText}</span>;
    }
  };

  return (
    <>
      <Wrapper>
        <PageTitle title="Складские документы" />
        <div className="row">
          <div className="col-12">
            <DocumentsCardWrapper>
              <div className="card">
                <DocumentsTabsWrapper>
                  <ul className="nav nav-tabs-orders" style={{ flexWrap: 'nowrap' }}>
                    {DOCUMENTS_PAGE_TABS.map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <div
                          data-toggle="tab"
                          aria-expanded="true"
                          className={`nav-link ${values.activeTab === tab.id ? 'active' : ''}`}
                          onClick={() => handleOpenTab(tab)}
                        >
                          <div className="d-flex flex-row">
                            <div className="nav-link-icon">
                              <i className={tab.icon} />
                            </div>
                            <div className="tab-title">{tab.title}</div>
                          </div>
                        </div>
                        <div
                          className={`nav-link-after ${
                            values.activeTab === tab.id ? 'active' : ''
                          }`}
                        />
                      </li>
                    ))}
                  </ul>
                </DocumentsTabsWrapper>
              </div>
              <div className="card-body">
                <FilterRow values={values} setFieldValue={setFieldValue} />
              </div>
            </DocumentsCardWrapper>
          </div>
        </div>
        <div className="card-body" style={{ marginTop: '-20px' }}>
          <Wrapper>
            <div className="fixed-table-container">
              <div className="fixed-table-body">
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <>
                        {THEAD_ITEMS.map((title) => (
                          <th>{title}</th>
                        ))}
                      </>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchedDocs !== null &&
                      fetchedDocs?.docs?.map((item) => {
                        return (
                          <tr>
                            <td>
                              <div className="title-cell">
                                <a href={item.url} target="_blank">
                                  <span>{item.title}</span>
                                </a>
                                <span>{moment(item.lastModifiedDate).format('DD.MM.YYYY')}</span>
                              </div>
                            </td>
                            <td>
                              <div className="title-cell">
                                <a href={`/supplies/${item.parentId}`} target="_blank">
                                  <span>{item.parentId}</span>
                                </a>
                              </div>
                            </td>
                            <td>
                              <div className="status-label">
                                {renderStatusSpan(item)}
                                {item.clientComment && (
                                  <i
                                    className="fe-message-circle"
                                    style={{ fontSize: '16px', marginLeft: '5px' }}
                                    title={item.clientComment}
                                  />
                                )}
                              </div>
                            </td>
                            <td>
                              <div
                                className="title-cell"
                                style={{ maxWidth: '300px', wordBreak: 'break-all' }}
                              >
                                <a href={item.signPerformerLink} target="_blank">
                                  <span>
                                    {moment(item.signPerformerDate).format(`YYYY-MM-DD HH:mm:ss`)}
                                  </span>
                                </a>
                                {item.signPerformerCertificateInfo && (
                                  <p>Подписант: {item.signPerformerCertificateInfo}</p>
                                )}
                              </div>
                            </td>
                            <td>
                              <div
                                className="title-cell"
                                style={{ maxWidth: '300px', wordBreak: 'break-all' }}
                              >
                                {item.signClientDate ? (
                                  <a href={item.signClientLink} target="_blank">
                                    <span>
                                      {moment(item.signClientDate).format(`YYYY-MM-DD HH:mm:ss`)}
                                    </span>
                                  </a>
                                ) : (
                                  <div className="status-label">
                                    <span className="color-not-present">Отсутствует</span>
                                  </div>
                                )}

                                {item.signClientCertificateInfo && (
                                  <p>Подписант: {item.signClientCertificateInfo}</p>
                                )}
                              </div>
                            </td>
                            <td>
                              <SignsBlock item={item} />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </Wrapper>
        </div>
        <Pagination
          withPerPageCountSelect
          total={fetchedDocs?.totalElements}
          currentPage={Number(values.page)}
          perPage={Number(values.size)}
          onPageSelect={(pageIndex) => setFieldValue('page', pageIndex)}
          onPerPageSelect={(count) => setFieldValue('size', count)}
          perPageSelectOptions={[
            { value: 15, label: 15 },
            { value: 40, label: 40 },
            { value: 100, label: 100 },
          ]}
          itemsNaming="заказов"
        />
      </Wrapper>
    </>
  );
};

export default DocumentsPage;
